// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IInvitationStatusEnumDto } from './invitation-status-enum-dto.g';

export const invitationUserDto = {
    guid: 'guid',
    domain_Name: 'domain_Name',
    status: 'status',
    expiresOn: 'expiresOn',
    domain_RequireTwoFactor: 'domain_RequireTwoFactor',
} as const;

export type TInvitationUserDto = (typeof invitationUserDto)[keyof typeof invitationUserDto];

export interface IInvitationUserDto {
    [invitationUserDto.guid]: string | null;
    [invitationUserDto.domain_Name]: string | null;
    [invitationUserDto.status]: IInvitationStatusEnumDto | null;
    [invitationUserDto.expiresOn]: string | null;
    [invitationUserDto.domain_RequireTwoFactor]: boolean | null;
}

export class InvitationUserDto
    implements IInvitationUserDto
{
    [invitationUserDto.guid]: string | null = null;
    [invitationUserDto.domain_Name]: string | null = null;
    [invitationUserDto.status]: IInvitationStatusEnumDto | null = null;
    [invitationUserDto.expiresOn]: string | null = null;
    [invitationUserDto.domain_RequireTwoFactor]: boolean | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IInvitationUserData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[invitationUserDto.guid] = modelData[invitationuserData.guid];
    }

    static create(modelData?: any | null): IInvitationUserDto | null {
        return modelData ? new InvitationUserDto(modelData) : null;
    }
}
